import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Icons } from 'src/utils/icons';



@Injectable({
    providedIn: 'root'
})
export class SvgService {
    private extraSvgs: string[] = [];
    constructor(
        @Inject(DOCUMENT) private document: Document,
    ) {}

    add(use: string, newUse: string) {
        this.extraSvgs.push(newUse);
        new Promise((resolve, reject) => {
            const svgRequest = new XMLHttpRequest();
            svgRequest.addEventListener('load', Icons.insertIcons);
            svgRequest.open('GET', use);
            svgRequest.setRequestHeader('Accept', 'image/svg+xml');
            svgRequest.onerror = () => reject('Icons request failed');
            svgRequest.ontimeout = () => reject('Icons request timedout');
            svgRequest.onabort = () => reject('Icons request aborted');
            svgRequest.onloadend = () => {
                svgRequest.removeEventListener('load', Icons.insertIcons);
                resolve({})
            };
            svgRequest.send();
        }).catch();
    }

    contains(use: string): boolean {
        return this.extraSvgs.includes(use);
    }
}
